<template>
  <div class="w-select">
    <div
      class="field"
      :style="{
        backgroundColor: tonal.gray[700],
      }"
      @click="toggle"
    >
      <div class="text">
        <span
          v-if="!selectedTitleComp"
          class="placeholder"
          :style="{
            color: tonal.white.white,
          }"
        >
          {{ placeholder }}
        </span>
        <span
          v-else
          class="selected"
          :style="{
            color: tonal.white.white,
          }"
        >
          {{ selectedTitleComp }}
        </span>
      </div>

      <div
        class="append-icon"
        :style="{ transform: !isOpen ? 'rotate(-180deg)' : 'rotate(0deg)' }"
      >
        <arrow-icon :color="tonal.white.white" :width="'38'" />
      </div>
    </div>

    <div
      v-if="isOpen"
      class="options-wrapper"
      :style="{
        backgroundColor: tonal.gray[800],
        borderColor: tonal.white.trans20,
      }"
    >
      <div class="options">
        <div
          v-for="(option, index) in options"
          :key="index"
          :class="['option', { selected: isSelected(option) }]"
          :style="{
            backgroundColor: isSelected(option) ? tonal.gray[600] : '',
          }"
          @click="selectOption(option)"
        >
          <span
            :style="{
              color: tonal.white.white,
            }"
            >{{ option.title }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, computed } from 'vue'
  import ArrowIcon from '@/components/ui/Select/icon/ArrowDown'
  import { tonal } from '@/constants/tonal'

  const props = defineProps({
    type: {
      type: String,
      default: 'default',
      validator: (value) =>
        ['default', 'primary', 'secondary', 'warning', 'danger'].includes(
          value,
        ),
    },
    placeholder: {
      type: String,
      default: '전체',
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
    },
  })
  const emit = defineEmits(['chagne'])

  const isOpen = ref(false)

  const selectedTitleComp = computed(() => {
    const option = props.options.find((option) => option.value === props.value)
    const title = option ? option.title : ''
    return option?.hideValue ? undefined : title
  })

  const selectOption = (option) => {
    emit('change', option)
    hide()
  }

  const isSelected = (option) => {
    return option.value === props.value
  }

  const hide = () => {
    isOpen.value = false
  }

  const show = () => {
    isOpen.value = true
  }

  const toggle = () => {
    if (isOpen.value) {
      hide()
    } else {
      show()
    }
  }

  const handleClickOutside = (event) => {
    if (!event.target.closest('.w-select')) {
      hide()
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside)
  })

  onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
  })
</script>

<style lang="scss" scoped>
  .w-select {
    position: relative;
    user-select: none;
    min-width: 240px;

    .field {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 12px;
      cursor: pointer;

      .text {
        flex-basis: 100%;
        padding: 12px 0 12px 20px;
        max-width: calc(100% - 42px);

        span {
          display: block;
          line-height: 24px;
          width: 100%;

          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          &.placeholder {
            width: 100%;
          }
        }
      }

      .append-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        transition: transform 0.15s ease-in-out;
      }
    }

    .options-wrapper {
      position: absolute;
      width: 100%;
      overflow: hidden;
      border: 1px solid;
      border-radius: 12px;
      margin-top: 4px;
      max-height: 384px;
      border-radius: 12px;
      overflow-y: scroll;
      z-index: 2;

      .options {
        cursor: pointer;

        .option {
          flex-basis: 100%;
          padding: 12px 20px;
          line-height: 24px;

          span {
            display: block;
            line-height: 24px;
            width: 100%;

            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
